import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { useIsKyivTemplate } from '~/utilities/useIsKyivTemplate';

const dividerBlockClasses = cva('', {
  variants: {
    pageDivider: {
      false: 'w-full border-0 my-4 bg-lightGrey',
      true: 'my-6',
    },
    width: {
      1: '',
      default: '',
    },
  },
  compoundVariants: [
    {
      pageDivider: false,
      width: 'default',
      class: 'h-1',
    },
    {
      pageDivider: false,
      width: 1,
      class: 'h-[1px]',
    },
  ],
});

export default component$(
  ({
    pageDivider = false,
    width = 'default',
  }: {
    pageDivider?: boolean;
    width?: 1 | 'default';
  }): JSX.Element => {
    const isKyiv = useIsKyivTemplate();
    return (
      <hr
        class={dividerBlockClasses({ pageDivider, width: isKyiv ? 1 : width })}
      />
    );
  }
);
